import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BaseApi } from 'src/backend/api/base-api';

@Injectable({
  providedIn: 'root'
})
export class TranslaterService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  currentLang: string;
  constructor(
    public translate: TranslateService,
    private http: HttpClient,
    private baseApi: BaseApi
  ) {
    translate.addLangs(['en', 'ar', 'fr', 'sp', 'gr', 'du']);
    // A default language must be set, otherwise ngx-translate has no translations at
    // all and every ('Tag' | translate) fallback renders the raw tag name.
    translate.setDefaultLang('en');
    // Retrieve the selected language from session storage, if available; always call
    // use() so the i18n file for the active language is actually loaded.
    const savedLang = this.baseApi.getLanguage() || 'en';
    this.switchLang(savedLang);
  }

  public switchLang(lang: string) {
    this.translate.use(lang);
    // Save the selected language to session storage
    localStorage.setItem('Language_Name', lang);
  }

  getLangWords(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Language/getLanguageTags', data);
  }

}
